import { route } from 'constant'

import { BreadcrumbItem } from 'components'

export const getBreadcrumbsData = (dynamicItem: BreadcrumbItem): BreadcrumbItem[] => {
  return [{ url: route.userManagement, title: 'User management' }, dynamicItem]
}
